type NewType = {
  oauthUrl: {
    [key: string]: string
  }
  identityUrl: {
    [key: string]: string
  }
  host: {
    [key: string]: string[]
  }
}

const url: NewType = {
  oauthUrl: {
    local: 'https://idbrokerbts.webex.com',
    qa: 'https://idbrokerbts.webex.com',
    bts: 'https://idbrokerbts.webex.com',
    prod: 'https://idbroker.webex.com',
    ite: 'https://idbroker.webex.umi.ai'
  },
  identityUrl: {
    local: 'https://identitybts.webex.com',
    qa: 'https://identitybts.webex.com',
    bts: 'https://identitybts.webex.com',
    prod: 'https://identity.webex.com',
    ite: 'https://identity.webex.umi.ai'
  },
  host: {
    local: ['127.0.0.1', 'localhost'],
    qa: ['mct.qa.webex.com'],
    bts: ['mctbt10.webex.com'],
    prod: ['mct.qa.webex.com']
  }
}

export default {
  getHost() {
    const key = Object.keys(url.host).filter((env) => {
      return url.host[env].includes(window.location.hostname)
    })
    return key.shift()
  },
  getIdentityUrl() {
    return url.identityUrl[this.getHost() as string]
  },
  getOAuthUrl() {
    return url.oauthUrl[this.getHost() as string]
  },
  getApiBaseUrl() {
    const currentURL = `${window.location.protocol}//${window.location.host}`
    const urlWordSplit = currentURL.split('/')
    const apiBaseUrl = [...urlWordSplit.slice(0, 3)].join('/')
    return apiBaseUrl
  }
}
